import React, { useState, useEffect } from "react";
import { Row, Col, Form, Tooltip, OverlayTrigger } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";

export default function TeamBox(props) {
  let thumbnail = require("images/ShowMeHow.jpg");
  thumbnail = <img className="thumbnail" src={`/datapulse${thumbnail}`} />;
  const options = {
    "Facebook Ads": "https://www.youtube.com/watch?v=D_ObP3SFbww",
    Youtube: "https://www.youtube.com/watch?v=WjFv07Atrwk",
    "Google Analytics": "https://www.youtube.com/watch?v=ZqFKZWPYeOQ",
    "Google Ads": "https://www.youtube.com/watch?v=_HoMRLW-QhY",
    "Microsoft Ads": "https://www.youtube.com/watch?v=auSg3xUMAq8",
    "Google Merchant": "https://www.youtube.com/watch?v=aYXKRpCTJpc",
    Shopify: "https://youtu.be/rbm6-CvsYaE",
    "DataFeedWatch App": "https://help.datafeedwatch.com/article/xsgi6yhcea-3202731-adding-shopify",
    "Google Search Console": "https://youtu.be/aMdyzHq5Pgg",
    "Google Business": "https://youtu.be/e1AvEHvOn1s",
    SEMRush: "https://www.dropbox.com/s/34i7c10b8t3kd5w/Setting-Up-Client-SEM-Rush.pdf?dl=0",
  };
  let adminAccessCheck = false;
  let standardAccessCheck = false;
  let semAccessCheck = false;
  let dataFeedAccessCheck = false;
  let checkMain = false;
  let collaborateAccessCheck = false;
  let editAccessCheck = false;
  let readAndAnalyzeAccessCheck = false;
  let manageUsersCheck = false;
  if (props.teamAccess !== null) {
    adminAccessCheck = props.teamAccess[props.title] ? props.teamAccess[props.title]["Full"] == "1" : false;
    collaborateAccessCheck = props.teamAccess[props.title] ? props.teamAccess[props.title]["Collaborate"] == "1" : false;
    editAccessCheck = props.teamAccess[props.title] ? props.teamAccess[props.title]["Edit"] == "1" : false;
    readAndAnalyzeAccessCheck = props.teamAccess[props.title] ? props.teamAccess[props.title]["Read and Analyze"] == "1" : false;
    manageUsersCheck = props.teamAccess[props.title] ? props.teamAccess[props.title]["Manage Users"] == "1" : false;
    standardAccessCheck = props.teamAccess[props.title] ? props.teamAccess[props.title]["Restricted"] == "1" : false;
    semAccessCheck = props.teamAccess[props.title] ? props.teamAccess[props.title]["Completed setup"] == "1" : false;
    dataFeedAccessCheck = props.teamAccess["DataFeedWatch App"] ? props.teamAccess["DataFeedWatch App"]["Completed setup"] == "1" : false;
    checkMain = !(props.teamAccess[props.title] == null) && props.teamAccess[props.title]["Exist"] == "1";
  }
  const [semSetupCheck, setSemSetupCheck] = useState(semAccessCheck);
  const [dfhSetupCheck, setDfhSetupCheck] = useState(dataFeedAccessCheck);
  const [mainCheck, setMainCheck] = useState(checkMain);
  const [check1, setCheck1] = useState(adminAccessCheck);
  const [check2, setCheck2] = useState(standardAccessCheck);
  const [collabCheck, setCollabCheck] = useState(collaborateAccessCheck);
  const [editCheck, setEditCheck] = useState(editAccessCheck);
  const [readCheck, setReadCheck] = useState(readAndAnalyzeAccessCheck);
  const [manageCheck, setManageCheck] = useState(manageUsersCheck);

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Tooltip information goes here
    </Tooltip>
  );
  return (
    <>
      {props.title === "SEMRush" || props.title === "DataFeedWatch App" ? (
        <div className="px-3" style={{ backgroundColor: "#E1E1E1", paddingTop: "28px", paddingBottom: "29px", height: "100%" }}>
          <Row className="">
            <Col className="col-1">
              <Form.Group controlid={props.title}>
                <CustomFormCheck
                  id={props.title + "main"}
                  title={props.title}
                  checked={mainCheck}
                  name={`team_access[${props.title}][Exist]`}
                  onChange={() => setMainCheck(!mainCheck)}
                />
              </Form.Group>
            </Col>
            <Col xs={10}>
              <h3 className="section-header mb-0" style={{ whiteSpace: "nowrap", paddingTop: "2px" }}>
                {props.title}
              </h3>
            </Col>
            {options[props.title] ? (
              <Col className="">
                <Row className="tooltip-show-me">
                  {/* <span style={{ cursor: "pointer" }}>
                    <CustomTooltip
                      delay={1700}
                      faClass="pr-2 text-info far fa-question-circle"
                      label={<span className="text-info nunito-regular f14 pl-2">Show me</span>}
                      message={
                        <a href={options[props.title]} target="_blank">
                          {thumbnail}
                        </a>
                      }
                    />
                  </span> */}
                </Row>
              </Col>
            ) : (
              <Col className="">
                <OverlayTrigger id="tooltip" placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
                  <Row className="tooltip-show-me">
                    <i className="pr-2 far fa-question-circle" style={{ color: "#3291C1", cursor: "pointer" }}></i>{" "}
                    <p className="" style={{ color: "#3291C1", cursor: "pointer" }}>
                      {" "}
                      Show me
                    </p>
                  </Row>
                </OverlayTrigger>
              </Col>
            )}
          </Row>
          <Row className="ml-4">
            <Col className="col-1">
              <Form.Group className="mb-0" controlid={props.title + "setup"}>
                <CustomFormCheck
                  disabled={mainCheck === false ? true : false}
                  id={`${props.title}Completed`}
                  onChange={() => setSemSetupCheck(!semSetupCheck)}
                  checked={semSetupCheck}
                  name={`team_access[${props.title}][Completed setup]`}
                />
              </Form.Group>
            </Col>
            <Col>Completed setup</Col>
          </Row>{" "}
          <Row className="ml-4" style={{ display: "none" }}>
            <Col className="col-1">
              <Form.Group className="mb-0" controlid={props.title + "setup"}>
                <CustomFormCheck
                  disabled={mainCheck === false ? true : false}
                  id={`${props.title}Incompleted`}
                  onChange={() => setSemSetupCheck(!semSetupCheck)}
                  checked={!semSetupCheck}
                  name={`team_access[${props.title}][Incompleted setup]`}
                />
              </Form.Group>
            </Col>
            <Col>Completed setup</Col>
          </Row>{" "}
          <Row>
            <div className="">
              <br></br>
            </div>
          </Row>
          <Row className="ml-4">
            <Col className="">
              {" "}
              <br></br>{" "}
            </Col>
          </Row>
        </div>
      ) : props.title === "Shopify" ? (
        <div className="py-4 px-3" style={{ backgroundColor: "#E1E1E1" }}>
          <Row className="">
            <Col className="col-1">
              <Form.Group controlid={props.title}>
                <CustomFormCheck
                  id={props.title + "main"}
                  checked={mainCheck}
                  name={`team_access[${props.title}][Exist]`}
                  onChange={() => setMainCheck(!mainCheck)}
                />
              </Form.Group>
            </Col>
            <Col xs={10}>
              <h3 className="section-header mb-0" style={{ paddingTop: "2px" }}>
                {props.title}
              </h3>
            </Col>
            {options[props.title] ? (
              <Col className="">
                <Row className="tooltip-show-me">
                  {/* <span style={{ cursor: "pointer" }}>
                    <CustomTooltip
                      delay={1700}
                      faClass="pr-2 text-info far fa-question-circle"
                      label={<span className="text-info nunito-regular f14 pl-2">Show me</span>}
                      name={`team_access[${props.title}][Completed setup]`}
                      message={
                        <a href={options[props.title]} target="_blank">
                          {thumbnail}
                        </a>
                      }
                    />
                  </span> */}
                </Row>
              </Col>
            ) : (
              <Col className="">
                <OverlayTrigger id="tooltip" placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
                  <Row className="tooltip-show-me">
                    <i className=" far fa-question-circle" style={{ color: "#3291C1", cursor: "pointer" }}></i>{" "}
                    <p className="" style={{ color: "#3291C1", cursor: "pointer" }}>
                      {" "}
                      Show me
                    </p>
                  </Row>
                </OverlayTrigger>
              </Col>
            )}
          </Row>
          <Row>
            <Col>
              <h4 className="pt-1 light-primary nunito-regular"> Access level granted:</h4>
            </Col>
          </Row>
          <Row className="ml-4">
            <Col className="col-1">
              <Form.Group className="mb-0" controlid={props.title + "admingroup"}>
                <CustomFormCheck
                  disabled={mainCheck === false ? true : false}
                  id={props.title + "admin"}
                  onChange={() => setCheck1(!check1)}
                  // onChange={() => {setCheck1(!check1)
                  //    setRequireCheck(!requireCheck)} }
                  checked={check1}
                  // required={requireCheck}
                  name={`team_access[${props.title}][Completed setup]`}
                />
              </Form.Group>
            </Col>
            <Col>
              <h4 className="pt-1 light-primary nunito-regular">Completed setup </h4>
            </Col>
          </Row>
        </div>
      ) : (
        <div className="py-4 px-3" style={{ backgroundColor: "#E1E1E1" }}>
          <Row className="">
            <Col className="col-1">
              <Form.Group controlid={props.title}>
                <CustomFormCheck
                  id={props.title + "main"}
                  checked={mainCheck}
                  name={`team_access[${props.title}][Exist]`}
                  onChange={() => setMainCheck(!mainCheck)}
                />
              </Form.Group>
            </Col>
            <Col xs={10}>
              <h3 className="section-header mb-0" style={{ paddingTop: "2px" }}>
                {props.title}
              </h3>
            </Col>
            {options[props.title] ? (
              <Col className="">
                <Row className="tooltip-show-me">
                  {/* <span style={{ cursor: "pointer" }}>
                    <CustomTooltip
                      delay={1700}
                      faClass="pr-2 text-info far fa-question-circle"
                      label={<span className="text-info nunito-regular f14 pl-2">Show me</span>}
                      message={
                        <a href={options[props.title]} target="_blank">
                          {thumbnail}
                        </a>
                      }
                    />
                  </span> */}
                </Row>
              </Col>
            ) : (
              <Col className="">
                {/* <OverlayTrigger id="tooltip" placement="top" delay={{ show: 250, hide: 400 }} overlay={renderTooltip}>
                  <Row className="tooltip-show-me">
                    <i className=" far fa-question-circle" style={{ color: "#3291C1", cursor: "pointer" }}></i>{" "}
                    <p className="" style={{ color: "#3291C1", cursor: "pointer" }}>
                      {" "}
                      Show me
                    </p>
                  </Row>
                </OverlayTrigger> */}
              </Col>
            )}
          </Row>
          <Row>
            <Col>
              <h4 className="pt-1 light-primary nunito-regular"> Access level granted:</h4>
            </Col>
          </Row>
          <Row className="ml-4">
            <Col className="col-1">
              <Form.Group className="mb-0" controlid={props.title + "admingroup"}>
                <CustomFormCheck
                  disabled={mainCheck === false ? true : false}
                  id={props.title + "admin"}
                  onChange={() => setCheck1(!check1)}
                  // onChange={() => {setCheck1(!check1)
                  //    setRequireCheck(!requireCheck)} }
                  checked={check1}
                  // required={requireCheck}
                  name={`team_access[${props.title}][Full]`}
                />
              </Form.Group>
            </Col>
            <Col>
              <h4 className="pt-1 light-primary nunito-regular">Full</h4>
            </Col>
          </Row>
          <Row className="ml-4">
            <Col className="col-1">
              <Form.Group className="mb-0" controlid={props.title + "standardgroup"}>
                <CustomFormCheck
                  disabled={mainCheck === false ? true : false}
                  id={props.title + "standard"}
                  onChange={() => setCheck2(!check2)}
                  // onChange={() => {setCheck2(!check2)
                  // setRequireCheck(!requireCheck)} }
                  checked={check2}
                  // required={requireCheck}
                  name={`team_access[${props.title}][Restricted]`}
                />
              </Form.Group>
            </Col>
            <Col>
              <h4 className="pt-1 light-primary nunito-regular">Restricted</h4>
            </Col>
          </Row>
        </div>
      )}
    </>
  );
}
